export default __webpack_public_path__ + "static/media/arrow-left.a96aa605.svg";